module.exports = __webpack_public_path__ + "media/images/icons/donation-close-f5d160b56b8033972ba00018c0ae8592.svg";